"use client"

import { usePathname } from "next/navigation"

interface PreviewBannerProps {
  locale: string
}

/**
 * A fixed banner shown at the top of the page when Umbraco preview / draft
 * mode is active. Gives editors a clear visual indicator and a one-click
 * button to exit preview mode.
 */
export default function PreviewBanner({ locale }: PreviewBannerProps) {
  const pathname = usePathname()
  const exitUrl = `/app-api/preview/disable?path=${encodeURIComponent(pathname || `/${locale}`)}`

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        padding: "8px 16px",
        backgroundColor: "#1a1a2e",
        color: "#ffffff",
        fontSize: "14px",
        fontFamily: "sans-serif",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: "#ff6b35",
          flexShrink: 0,
        }}
      />
      <span>Preview Mode</span>
      <a
        href={exitUrl}
        style={{
          marginInlineStart: "8px",
          padding: "4px 12px",
          backgroundColor: "#ffffff",
          color: "#1a1a2e",
          borderRadius: "4px",
          textDecoration: "none",
          fontSize: "12px",
          fontWeight: 700,
        }}
      >
        Exit Preview
      </a>
    </div>
  )
}
